import { render } from "./DeliveryDetail.vue?vue&type=template&id=3ef3fda9&scoped=true"
import script from "./DeliveryDetail.vue?vue&type=script&lang=js"
export * from "./DeliveryDetail.vue?vue&type=script&lang=js"

import "./DeliveryDetail.vue?vue&type=style&index=0&id=3ef3fda9&scoped=true&lang=scss"

import exportComponent from "/var/www/driveapp2.locatiers.fr/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ef3fda9"]])

export default __exports__